import constants from 'constants/constants';
import moment from 'moment-timezone';

import { IMilestoneMapper } from 'components/pages/PhasePerformanceManagePage/components/Manage/Manage.types';

export const getEffectiveDate = (milestone: IMilestoneMapper, isStartDate: boolean): number => {
    return isStartDate ? milestone.calculatedStartDate : milestone.calculatedFinishDate;
};

export const formatEffectiveDateLabel = (milestone: IMilestoneMapper, isStartDate: boolean): string => {
    return moment(getEffectiveDate(milestone, isStartDate)).format(constants.formats.date.default);
};
